import { render, staticRenderFns } from "./CatalogContentDialog.vue?vue&type=template&id=6f487f82&scoped=true"
import script from "./CatalogContentDialog.vue?vue&type=script&lang=js"
export * from "./CatalogContentDialog.vue?vue&type=script&lang=js"
import style0 from "./CatalogContentDialog.vue?vue&type=style&index=0&id=6f487f82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f487f82",
  null
  
)

export default component.exports